export default "__VITE_PUBLIC_ASSET__2de0b73b__"